angular.module('NiacsProjectApp.services-resources', [
  'NiacsProjectApp.services-jsonapi',
  'NiacsProjectApp.services-general'
])
.factory('NiacsProject',['$jsonApiResource',function($jsonApiResource) {
  var type_def = {
    id: {attribute:'drupal_internal__nid'},
    created: {attribute:'created',type:'timestamp'},
    changed: {attribute:'changed',type:'timestamp'},
    author: {relationship:'uid',type:'user',bundle:'user',nested:'mail'},
    json: {attribute:'body',nested:'value'}, // JSON string
    label: {attribute:'title'},
    acres: {attribute:'field_proj_acres',type:'number'},
    size: {attribute:'field_proj_size'},
    vuln_region: {relationship:'field_proj_var_ref',type:'node',bundle:'niacs_vuln_assmnt_region',nested:'drupal_internal__nid'},
    state: {relationship:'field_proj_state',type:'taxonomy_term',bundle:'state',nested:'drupal_internal__tid'},
    state_name: {relationship:'field_proj_state',type:'taxonomy_term',bundle:'state',nested:'name'},
    ownership: {relationship:'field_proj_ownership',type:'taxonomy_term',bundle:'niacs_project_ownership',nested:'drupal_internal__tid'},
    ownership_name: {relationship:'field_proj_ownership',type:'taxonomy_term',bundle:'niacs_project_ownership',nested:'name'},
    course: {relationship:'field_related_course',type:'node',bundle:'course',nested:'drupal_internal__nid'},
    course_offering: {attribute:'field_related_course_offering',type:'number'}
  };
  var NiacsProject = $jsonApiResource('node','niacs_project',type_def);
  // over-ride the default s11n/des11n logic to deal with storing project data as JSON on the node body
  NiacsProject.prototype.$populateFromJsonApiResponse = (function(superFunc){
      return function() {
        superFunc.apply(this,arguments);
        // some queries exclude project content looking for just metdata
        var _o = !!this.json ? JSON.parse(this.json) : {};
        delete this.json;
        Object.assign(this,_o);
        if(this.course && this.course_offering) {
          // the bespoke server logic did this on the server side
          // the client however writes the ids back as course/course_offering
          // so just leaving them in place rather than deleting them
          this.training = this.training||{};
          this.training.course = this.course;
          this.training.course_offering = this.course_offering;
        }
      };
    })(NiacsProject.prototype.$populateFromJsonApiResponse);


  NiacsProject.prototype.$p_write = function(method,callback) {
    var self = this;
    return self.$serialize().then(function(data) {
      var body_value = JSON.parse(angular.toJson(self));
      // remove stuff from JSON that's stored on the node itself
      Object.keys(type_def).forEach(function(key) { delete body_value[key]; });
      data.attributes.body = { value: angular.toJson(body_value) };
      return self.$action(method,data).then(function(o)  {
        if(callback) {
          callback(o);
        }
        return o;
      });
    });
  };

  NiacsProject.prototype.$update = function(callback) {
    return this.$p_write('patch',callback);
  };
  NiacsProject.prototype.$save = function(callback) {
    return this.$p_write('post',callback);
  };

  return NiacsProject;
}])
.factory('NiacsResource',['$jsonApiResource',
    function($jsonApiResource){
      var NiacsResource = $jsonApiResource('node','resource',{
          id: {attribute:'drupal_internal__nid'},
          created: {attribute:'created',type:'timestamp'},
          changed: {attribute:'changed',type:'timestamp'},
          attachment: {relationship:'field_resource_attachment',type:'file'},
          author: {attribute:'field_resource_author'},
          date: {attribute:'field_resource_date'},
          description: {attribute:'body',nested:'value'},
          label: {attribute:'title'},
          link: {attribute:'field_resource_link',type:'link'},
          pages: {attribute:'field_resource_pages'},
          region: {attribute:'field_resource_region'},
          sectors: {relationship:'field_applicable_sectors',type:'taxonomy_term',bundle:'strategy_source',nested:'field_taxonomy_machine_name'},
          source: {relationship:'field_resource_source',type:'taxonomy_term',bundle:'attribution_source',nested:'name'},
          step: {relationship:'field_resource_step',type:'taxonomy_term',bundle:'steps',nested:'name'},
          sticky: {attribute:'sticky',type:'boolean'},
          volume: {attribute:'field_resource_volume'},
        });
      return NiacsResource;
}])
.factory('NiacsClimateImpactStatement',['$jsonApiResource','$q','NiacsResource',function($jsonApiResource,$q,NiacsResource) {
  var NiacsClimateImpactStatement = $jsonApiResource('node','niacs_cis',{
      id: {attribute:'drupal_internal__nid'},
      created: {attribute:'created',type:'timestamp'},
      changed: {attribute:'changed',type:'timestamp'},
      label: {attribute:'title'},
      statement: {attribute:'body',nested:'value'},
      local_link: {relationship:'field_cis_local_link',type:'file'},
      external_link: {attribute:'field_cis_external_link',type:'link'},
      sectors: {relationship:'field_applicable_sectors',type:'taxonomy_term',bundle:'strategy_source',nested:'field_taxonomy_machine_name'},
      evidence: {relationship:'field_cis_evidence',type:'taxonomy_term',bundle:'niacs_cis_evidence',nested:'name'},
      agreement: {relationship:'field_cis_agreement',type:'taxonomy_term',bundle:'niacs_cis_agreement',nested:'name'},
      resources: {relationship:'field_cis_resource',type:NiacsResource}
    });
  /**
   * ClimateImpactStatements are stored on the server side as outgoing references and the
   * order of those references is meaningful.  Unit/Var use this function to load their associated impacts
   * so this function queries for impact statements given a list of ids and sorts the results based on that
   * input list.
   * 
   * @todo JSON API has a hard paging limit of 50 so this will break if/when a Var or Unit stores more than 50 references
   * @param {string} ids The list of climate impact ids to fetch
   * @returns {Promise} that resolves to the list of NiacsClimateImpactStatement Resource instances.
   */
  NiacsClimateImpactStatement.$loadByIdList = function(ids) {
    ids = ids||[];
    // if they're asking for a list of no ids then avoid the trip to the server
    if(ids.length === 0) {
        var def = $q.defer();
        def.resolve([]);
        return def.promise;
    }
    var params = {
        'filter[id-filter][condition][path]': 'id',
        'filter[id-filter][condition][operator]': 'IN',
        'page[limit]':999
    };
    ids.forEach(function(id,i) {
        params['filter[id-filter][condition][value]['+i+']'] = id;
    });
    return NiacsClimateImpactStatement.query(params)
        .$promise.then(function(listResponse) {
            return listResponse.list.sort(function(a,b) {
                return ids.indexOf(a.$uuid()) - ids.indexOf(b.$uuid());
            });
        });
  };
  return NiacsClimateImpactStatement;
}])
.factory('NiacsUnit',['$jsonApiResource','NiacsClimateImpactStatement',function($jsonApiResource,NiacsClimateImpactStatement) {
  var NiacsUnit = $jsonApiResource('node','niacs_unit',{
      id: {attribute:'drupal_internal__nid'},
      created: {attribute:'created',type:'timestamp'},
      changed: {attribute:'changed',type:'timestamp'},
      label: {attribute:'title'},
      description: {attribute:'body',nested:'value'},
      adaptive_capacity: {attribute:'field_unit_adaptive_capacity',type:'number'},
      potential_impacts: {attribute:'field_unit_potential_impacts',type:'number'},
      local_link: {relationship:'field_unit_local_link',type:'file'},
      external_link: {attribute:'field_unit_external_link',type:'link'},
      sectors: {relationship:'field_applicable_sectors',type:'taxonomy_term',bundle:'strategy_source',nested:'field_taxonomy_machine_name'},
      unit_vulnerability: {relationship:'field_unit_vulnerability',type:'taxonomy_term',bundle:'niacs_unit_vulnerability',nested:'name'}
    });
  NiacsUnit.prototype.$getClimateImpacts = function() {
    return NiacsClimateImpactStatement.$loadByIdList(this.$jsonApi.relatedId('field_unit_cis_ref'));
  };
  return NiacsUnit;
}])
.factory('NiacsVulnAssmntRegion', ['$jsonApiResource','NiacsUnit','NiacsClimateImpactStatement',function($jsonApiResource,NiacsUnit,NiacsClimateImpactStatement) {
      var NiacsVulnAssmntRegion = $jsonApiResource('node','niacs_vuln_assmnt_region',{
          id: {attribute:'drupal_internal__nid'},
          created: {attribute:'created',type:'timestamp'},
          changed: {attribute:'changed',type:'timestamp'},
          label: {attribute:'title'},
          description: {attribute:'body',nested:'value'},
          geojson: {relationship:'field_niacs_geojson',type:'file'},
          geojson_buffered: {relationship:'field_niacs_geojson_buffered',type:'file'},
          state: {relationship:'field_niacs_state',type:'taxonomy_term',bundle:'state',nested:'name'},
          link: {attribute:'field_var_link',type:'link'},
          video_link: {attribute:'field_var_video_link',type:'link'},
          deprecated: {attribute:'field_deprecated',type:'boolean'},
        });
      NiacsVulnAssmntRegion.query = (function(superFunc) {
        return function (p1,p2) {
            var params,callback;
            if(typeof(p1) === 'function') {
                callback = p1;
            } else {
                params = p1;
                callback = p2;
            }
            params = params||{};
            var includeDeprecated = params.includeDeprecated;
            delete params.includeDeprecated;
            if(!includeDeprecated && !params['filter[drupal_internal__nid][value]']/*get calls use, you ask for it you get it*/) {
                // to find not deprecated need to query for NULL (not touched since deprecated flag introduced) or false
                params['filter[not-deprecated][group][conjunction]'] = 'OR';

                params['filter[deprecated-notset][condition][path]'] = 'field_deprecated';
                params['filter[deprecated-notset][condition][operator]'] = 'IS NULL';
                params['filter[deprecated-notset][condition][memberOf]'] = 'not-deprecated';
                
                params['filter[deprecated-set][condition][path]'] = 'field_deprecated';
                params['filter[deprecated-set][condition][operator]'] = '=';
                params['filter[deprecated-set][condition][value]'] = false;
                params['filter[deprecated-set][condition][memberOf]'] = 'not-deprecated';
            }
            return superFunc.call(this,params,callback);
        };
      })(NiacsVulnAssmntRegion.query);
      NiacsVulnAssmntRegion.prototype.$getUnits = function() {
          // outgoing reference field_niacs_unit_ref, could use get and expand or
          // fetch IN, doing the latter since the functionality already exists.
          // this _could_ result in very long query args, hopefully not too long...
          var params = {
              'filter[id-filter][condition][path]': 'id',
              'filter[id-filter][condition][operator]': 'IN',
              'page[limit]':999
          };
          this.$jsonApi.relatedId('field_niacs_unit_ref').forEach(function(id,i) {
            params['filter[id-filter][condition][value]['+i+']'] = id;
          });
          return NiacsUnit.query(params).$promise.then(function(listResponse) { return listResponse.list; });
        };
      NiacsVulnAssmntRegion.prototype.$getClimateImpacts = function() {
        return NiacsClimateImpactStatement.$loadByIdList(this.$jsonApi.relatedId('field_var_cis_ref'));
      };
      return NiacsVulnAssmntRegion;
}])
.factory('NiacsCustomizableText',['$jsonApiResource',
    function($jsonApiResource){
      var NiacsCustomizableText = $jsonApiResource('node','niacs_customizable_text',{
          id: {attribute:'drupal_internal__nid'},
          created: {attribute:'created',type:'timestamp'},
          changed: {attribute:'changed',type:'timestamp'},
          label: {attribute:'title'},
          description: {attribute:'body',nested:'value'},
          sector: {relationship:'field_applicable_sector',type:'taxonomy_term',bundle:'strategy_source',nested:'field_taxonomy_machine_name'},
        });
      return NiacsCustomizableText;
}]);
